import React, {
	useContext, useEffect, useMemo, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { VideoCacheContext } from '../../contexts/media/video-queue';
import Socket, { ConnectedUser } from '../../connection/socket';
import useShots from '../../hooks/use-shots';
import { GreenroomState } from '../../stores/types/types';
import SpotlightConnector from './spotlight-connector';
import MediaVideoSpotlight from '../general-components/media-video-spotlight';
import { connectorIdLive, projectedComponentIdLive } from './spotlight-utils';
import { ShotFeed } from '../../stores/reducers/shots';
import FeedMediaSpotlight from '../main-video/feed-media-spotlight';

interface SpotlightManagerProps {
  socket: Socket | null;
  iterateLoadedMediaCount?: Function;
}

const SpotlightManager: React.FC<SpotlightManagerProps> = ({
	socket,
	iterateLoadedMediaCount,
}) => {
	const media = useSelector((state: GreenroomState) => state.MediaReducer.media);
	const [spotlightElements, setSpotlightElements] = useState<JSX.Element[]>([]);
	const {
		currentShot,
	} = useShots();

	const {
		shot_data: {
			shotFeeds,
		},
	} = currentShot;

	const { preloadedElements } = useContext(VideoCacheContext);

	const audioOnlyFeeds = useMemo(() => (shotFeeds?.length > 0
		? shotFeeds.filter((shotFeed) => shotFeed.audioOnly)
		: []), [shotFeeds]);

	useEffect(() => () => {
		console.log('SpotlightManager unmounting');
	}, []);

	const Spotlights = useMemo(() => {
		const otherSpotlights:any = {};
		preloadedElements?.current?.get('next-shot')?.forEach((arrayOfPages, key) => {
			const mediaItem = media.find((m) => m.id === key);

			const isAudioOnly = audioOnlyFeeds.some((feed:any) => feed.media === key);
			arrayOfPages.forEach((value) => {
				if (value) {
					const desiredContainerId = projectedComponentIdLive(key, value);
					const uniqueSpotlightId = connectorIdLive(key, value);
					otherSpotlights[`${key}-${value}`] = {
						desiredContainerId: 'hidden-spotlight',
						uniqueSpotlightId,
						id: `media-video-${key}-${isAudioOnly ? '-audio-only' : ''}`,
						key: `${'key_FeedMedia_'}${key}${isAudioOnly ? '-audio-only' : ''}`,
						mediaId: key,
						className: 'media-video',
						iterateLoadedMediaCount,
						socket,
						isPreloading: true,
						doEchoCancel: true,
						audioOnly: isAudioOnly,
						isEditingFeed: false,
						// Here we can set a the showBackground, which may not even need anymore
						// onCanPlayThrough: () => setShowBackground(true),
						loop: !!mediaItem?.media_data.loop,
						isForMainVideoEditingComponent: false,
					};
				}
			});
		});

		preloadedElements?.current?.get('current-shot')?.forEach((arrayOfPages, key) => {
			const mediaItem = media.find((m) => m.id === key);
			const currentShotPosition = currentShot?.shot_data?.shotFeeds?.find((feed) => feed.media === key)?.position;
			// the id of the video container should be the same as the feed media feedPosition.

			const isAudioOnly = audioOnlyFeeds.some((feed:any) => feed.media === key);

			arrayOfPages.forEach((value) => {
				if (value) {
					const desiredContainerId = projectedComponentIdLive(key, value);
					const uniqueSpotlightId = connectorIdLive(key, value);
					if (otherSpotlights[`${key}-${value}`]) {
						otherSpotlights[`${key}-${value}`].desiredContainerId = `feed-${currentShotPosition}`;
						otherSpotlights[`${key}-${value}`].isPreloading = false;
					} else {
						otherSpotlights[`${key}-${value}`] = {
							desiredContainerId: `feed-${currentShotPosition}`,
							uniqueSpotlightId,
							id: `media-video-${key}-${isAudioOnly ? '-audio-only' : ''}`,
							key: `${'key_FeedMedia_'}${key}${isAudioOnly ? '-audio-only' : ''}`,
							mediaId: key,
							className: 'media-video',
							iterateLoadedMediaCount,
							socket,
							isPreloading: false,
							doEchoCancel: true,
							audioOnly: isAudioOnly,
							isEditingFeed: false,
							// Here we can set a the showBackground, which may not even need anymore
							// onCanPlayThrough: () => setShowBackground(true),
							loop: !!mediaItem?.media_data.loop,
							isForMainVideoEditingComponent: false,
						};
					}
				}
			});
		});

		return <>{Object.keys(otherSpotlights).map((value, index) => (
				<SpotlightConnector
					uniqueSpotlightId={otherSpotlights[value].uniqueSpotlightId}
					desiredContainerId={otherSpotlights[value].desiredContainerId}
					mediaId={otherSpotlights[value].mediaId}
					key={otherSpotlights[value].key}
				>
					<MediaVideoSpotlight
						{...otherSpotlights[value]}
					/>
				</SpotlightConnector>
		))}
		</>;
	}, [preloadedElements?.current, media, audioOnlyFeeds, iterateLoadedMediaCount, socket, currentShot.shot_id]);

	return (

    <div>
      {Spotlights}
    </div>
	);
};

export default SpotlightManager;
